// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"494":"ab34bfa2","787":"72b6eb0f","963":"efc113e5"}[chunkId] + ".chunk.js";
};